'use strict';
/**
 * data-sw-set-cookie
 *
 * Used to set a target for making a cookie on click. This is helpful for
 * saving acknowledgement of a message.
 *
 * data-sw-set-cookie="<cookieKey>"
 *    string used as key to define what cookie is to be set
 *
 */
var $ = require('js/sw-jquery/sw-jquery');
var sw = require('js/lib/sw');
$(document).ready(function() {

  $('body').on('click', '[data-sw-set-cookie]', function() {
    var cookie;

    switch($(this).data('swSetCookie')) {
      case 'euCookie':
        cookie = sw.data.euCookieNoticeCookie;
        break;
      case 'securityNotice716':
        cookie = sw.data.generalSecurityNotice716Cookie;
        break;
    }

    if(cookie) {
      document.cookie = cookie;
    }

  });

});
